import styled from 'styled-components';

export const FullScreenOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: ${({ theme }) => theme.layers.modal};
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.white};
`;

export const OverlayContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 24px;
  max-width: 480px;
  text-align: center;
`;

export const ErrorContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  font-weight: 400;
  color: ${({ theme }) => theme.colors.neutral.primaryNavy};
  font-size: 18px;
  line-height: 20px;
`;

export const ErrorTextContainer = styled.div`
  padding: 10px 0 20px 0;
`;
